export class ApiError extends Error {
  status: number
  code: string
  body: Record<string, unknown>

  constructor(status: number, code: string, message: string, body: Record<string, unknown>) {
    super(message)
    this.name = "ApiError"
    this.status = status
    this.code = code
    this.body = body
  }
}

function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  let res: Response
  try {
    res = await fetch(path, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
        ...(init?.body ? { "Content-Type": "application/json" } : {}),
      },
      ...init,
    })
  } catch {
    throw new ApiError(0, "network_error", "Falha de conexão. Verifique sua internet.", {})
  }

  if (res.status === 401) {
    // Sessão expirada — voltar pro login
    window.location.href = "/login"
    throw new ApiError(401, "unauthorized", "Sessão expirada", {})
  }

  if (!res.ok) {
    let body: Record<string, unknown> = {}
    try {
      body = await res.json()
    } catch {
      // corpo não-JSON
    }
    const code = typeof body.error === "string" ? body.error : "unknown_error"
    const message = typeof body.message === "string" ? body.message : `Erro ${res.status}`
    throw new ApiError(res.status, code, message, body)
  }

  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}

export const api = {
  get<T>(path: string): Promise<T> {
    return request<T>(path)
  },
  post<T>(path: string, body?: unknown): Promise<T> {
    return request<T>(path, {
      method: "POST",
      body: body === undefined ? undefined : JSON.stringify(body),
    })
  },
  patch<T>(path: string, body?: unknown): Promise<T> {
    return request<T>(path, {
      method: "PATCH",
      body: body === undefined ? undefined : JSON.stringify(body),
    })
  },
  del<T>(path: string): Promise<T> {
    return request<T>(path, { method: "DELETE" })
  },
}
